// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ResearchInterestTags-cls1___c6d8b8fc15ff6e31c14{/*!*/}.ResearchInterestTags-cls2__b1227eda698e6abd3dd1{font-size:16px;position:relative;display:flex;flex-direction:column;width:100%;background-color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ResearchInterestTags-cls1___c6d8b8fc15ff6e31c14",
	"cls2": "ResearchInterestTags-cls2__b1227eda698e6abd3dd1 ResearchInterestTags-cls1___c6d8b8fc15ff6e31c14"
};
export default ___CSS_LOADER_EXPORT___;
